export enum BusinessActivityType {
    ANCILLARY_SERVICE_PROVIDER = 1,
    REGULATED_ACTIVITIES = 2,
    MARKET_ACTIVITIES = 3,
    NON_FINANCIAL_ACTIVITIES = 4,
    SCP_ON_FINANCIAL_ACTIVITIES = 5,
}

export const BUSINESS_ACTVITY_TYPE_MAP: Map<number, string> = new Map([
    [BusinessActivityType.ANCILLARY_SERVICE_PROVIDER, 'Ancillary Service Provider'],
    [BusinessActivityType.REGULATED_ACTIVITIES, 'Regulated Activities'],
    [BusinessActivityType.MARKET_ACTIVITIES, 'Market Activities'],
    [BusinessActivityType.NON_FINANCIAL_ACTIVITIES, 'Non-financial activities'],
    [BusinessActivityType.SCP_ON_FINANCIAL_ACTIVITIES, 'Non-financial activities'],
])
